import { useStore, useData } from '../../store';
const { channel } = useStore();
const { init_data, login_status } = useData();
export default {
  mounted(el, binding) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 有一些数据是依赖于登录状态的，所以一定要数据加载好才能进行发送
          setTimeout(() => {
            const logMessage = binding.value;
            let data = new FormData();
            data.append('activity', import.meta.env.VITE_NAME);
            // data.append('op_code', 'login')
            data.append(
              'details',
              JSON.stringify({
                page_home: logMessage.name,
              })
            );
            data.append(
              'server_group',
              import.meta.env.VITE_TEAM == 'tx2' ? 2 : 1
            );
            data.append('channel', channel.channel);
            if (login_status.value) {
              if (Object.keys(init_data.role_info).length) {
                data.append('h5user_id', '');
                data.append('role_name', '');
                data.append('role_id', '');
              }
              data.append('account_id', init_data.account_data.username);
            } else {
              data.append('h5user_id', window.figureCode);
            }
            fetch(`${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log `, {
              method: 'POST',
              body: data,
            });
            observer.unobserve(el);
          }, 5000);
        }
      });
    });

    observer.observe(el);
  },
};
